import NextPageWithServices from "@insightfulscience/smart-react/hocs/NextPageWithServices";
import revalidateService from "@insightfulscience/contentful/services/revalidateService";
import { publicConfig } from "../config";
import recoveryService from "./recoveryService";
import gqlClient from "./gqlClient";
import pureGqlClient from "./gqlClient/pure";
import authService from "./authService";
import trialService from "./trialService";
import { apiMock } from "./storageService/apiMock";
import ecommerceService from "./ecommerceService";
import routingService from "./routingService";
import gqlEventsListener from "./GtmGqlEvents";
import { persistent } from "./persistentStorage";
import daClient from "./daClient";
import { notifySentry } from "../sentry";
import zendeskService from "./zendeskService";
import contentfulService from "./contentfulService";
import { pagePaths } from "../domain/revalidate";

export const serviceCore = {
	publicConfig: () => publicConfig,
	...persistent,
	recoveryService,
	gqlClient,
	pureGqlClient,
	authService,
	routingService,
	gqlEventsListener,
	trialService,
	ecommerceService,
	apiMock,
	daClient,
	reportError: () => notifySentry,
	zendeskService,
	contentfulService,
	pagePaths: () => pagePaths,
	revalidateService,
};

export default NextPageWithServices(serviceCore);
